import { render, staticRenderFns } from "./DomainTable.vue?vue&type=template&id=0ea46a78&"
import script from "./DomainTable.vue?vue&type=script&lang=js&"
export * from "./DomainTable.vue?vue&type=script&lang=js&"
import style0 from "./DomainTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports